(function () {
	'use strict';

	angular.module('qbePortal').controller('qbRangeBar', qbRangeBar);

	qbRangeBar.$inject = ['$scope', 'labelService', '$timeout'];

	function qbRangeBar($scope, labelService, $timeout) {
		var vm = this;
		console.info(vm.value);

		vm.getAverageWidth = function () {
			var averageWidth = {'width': '10%'};

			if (!!vm.minimum && !!vm.maximum && !!vm.average) {

				vm.total = (vm.maximum - vm.minimum);
				vm.averageWidth = (vm.average - vm.minimum) / vm.total * 100;
				averageWidth = {'width': vm.averageWidth + '%'};
			}

			return averageWidth;
		};

		vm.getCirclePos = function () {
			if (!!vm.value) {
				if (vm.value >= vm.minimum && vm.value <= vm.maximum) {
					var pos = (vm.value - vm.minimum) / vm.total * 100;
					return {'left': pos + '%'};
				}
				else if (vm.value > vm.maximum) {
					vm.value = vm.maximum;
					return {'left': '100%'};
				}
				else if (vm.value < vm.minimum) {
					vm.value = vm.minimum;
					return {'left': '0%'};
				}
			}
			else {
				return {'left': '0%'};
			}
		};
		vm.getAveragePos = function () {
			if (!!vm.averageWidth) {
				var pos = (vm.averageWidth - 17) * -1;
				return {'left': pos + '%'};
			}
		};
	}

	angular.module('qbePortal').component('qbRangeBar', {
		templateUrl: '/ngviews/components/qbRangeBar.html',
		controller: qbRangeBar,
		controllerAs: 'vm',
		bindings: {
			value: '@',
			minimum: '<',
			maximum: '<',
			average: '<'
		}
	});
})();
